// Misc
import React from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup } from 'react-transition-group'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Grow from '@material-ui/core/Grow'
import Fade from '@material-ui/core/Fade'
import Typography from '@material-ui/core/Typography'
import ExpandBase from 'atoms/ExpandBase'

// Styles
const styles = theme => ({
  label: {
    cursor: 'pointer',
    minHeight: '2rem',
    display: 'inline-flex',
    verticalAlign: 'top',
    alignItems: 'center',
    outline: 0,
  },
  content: {
    transformOrigin: 'left top',
    paddingLeft: theme.spacing.unit * 3,
  },
})

const Expand = ({ label, expanded, children, classes, onToggle, ...rest }) => (
  <ExpandBase expanded={expanded} onToggle={onToggle} {...rest}>
    <TransitionGroup exit={false}>
      { expanded
        && (
        <Grow>
          <div className={classes.content}>
            { children }
          </div>
        </Grow>
        )
      }
      { !expanded
        && (
        <Fade>
          <div className={classes.content}>
            <Typography
              tabIndex="-1"
              variant="caption"
              color="textSecondary"
              onClick={onToggle}
              className={classes.label}
            >
              { label }
            </Typography>
          </div>
        </Fade>
        )
      }
    </TransitionGroup>
  </ExpandBase>
)

Expand.propTypes = {
  classes: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.any,
  label: PropTypes.any,
}

export default withStyles(styles)(Expand)
